module.exports = __webpack_public_path__ + "img/mobile-airport-thumb.4f4ceded.png";